import { useCallback } from 'react'

import { useGetSearchKeywordQuery } from '@/generated/graphql-types'
import { updateSearchKeywordCache } from '@/utils/keyword/updateSearchKeywordCache'

export const useGetSearchKeyword = (): {
  keyword: string
  updateSearchKeyword: (newKeyword: string) => void
} => {
  const { data, client } = useGetSearchKeywordQuery()

  const keyword = data?.srp.searchKeyword || ''

  const updateSearchKeyword = useCallback(
    (newKeyword?: string) => {
      /** Update Cache */
      updateSearchKeywordCache(newKeyword, client)
    },
    [client]
  )

  return { keyword, updateSearchKeyword }
}
